// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const ms = {
  games: 'Permainan',
  game_history: 'Sejarah Permainan',
  bet_amount: 'Jumlah Pertaruhan',
  login: 'Log Masuk',
  register: 'Daftar',
  username_placeholder: 'Nama Pengguna',
  please_input_your_x: 'Sila Masukkan {{x}} Anda',
  verification_code: 'Kod Pengesahan',
  press_get_code: 'Tekan butang DAPATKAN KOD untuk menerima kod pengesahan melalui SMS',
  otp_sent: 'Kod Pengesahan Dihantar! Masukkan kod pengesahan di bawah untuk meneruskan',
  your_otp_expire: 'Kod OTP anda akan tamat dalam',
  get_code: 'DAPATKAN KOD',
  didnt_receive: 'Tidak menerima mesej?',
  send_again: 'Hantar Semula',
  captcha: 'CAPTCHA',
  forgot_password: 'Lupa Kata Laluan',
  minor_note: 'Untuk melawat laman ini, pastikan anda berumur lebih 18 tahun dan bersetuju',
  terms_of_service: 'Terma Perkhidmatan',
  by_signing_in: 'Dengan Log Masuk atau Daftar, anda bersetuju dengan',
  dont_have_account: 'Tidak mempunyai akaun?',
  sign_up: 'Daftar',
  username: 'Nama Pengguna',
  email: 'E-mel',
  full_name: 'Nama Penuh',
  confirm_18: 'Saya mengesahkan bahawa saya berumur 18 tahun dan telah membaca',
  already_have_account: 'Sudah mempunyai akaun?',
  deposit: 'Deposit',
  bonus: 'Bonus',
  load_more: 'Muatkan Lagi',
  responsible_gaming: 'Permainan Bertanggungjawab',
  faq: 'FAQ',
  amount: 'Jumlah',
  extra: 'Tambahan',
  deposit_bonus: 'Bonus Deposit',
  withdraw: 'Pengeluaran',
  min: 'Min:',
  max: 'Maks:',
  notifications: 'Pemberitahuan',
  invalid_x: 'Tidak sah {{x}}',
  captcha_not_match: 'Captcha Tidak Sepadan',
  invalid_x_must_be_atleast_y_characters: 'Tidak sah {{x}}, mesti sekurang-kurangnya {{y}} aksara',
  x_is_required: '{{x}} diperlukan',
  phone_number: 'Nombor Telefon',
  phone_num_x_max: 'Nombor Telefon maksimum {{x}} digit',
  email_sent: 'E-mel dihantar, sila semak e-mel anda.',
  enter_valid_email: 'Sila masukkan e-mel yang sah.',
  confirm: 'Sahkan',
  password_atleast_6_characters: 'Kata laluan mesti sekurang-kurangnya 6 aksara.',
  password_reset_success: 'Kata laluan berjaya ditetapkan semula!',
  new_password: 'Kata Laluan Baru',
  bank: 'Bank',
  bank_name: 'Nama Bank',
  bank_branch: 'Cawangan Bank',
  pay_id: 'ID Pembayaran',
  account_name: 'Nama Akaun',
  account_number: 'Nombor Akaun',
  drop_or_select: 'Letakkan atau Pilih fail',
  drop_files_here: 'Letakkan fail di sini',
  transfer_to: 'Pindah Ke',
  upload_receipt: 'Muat Naik Resit',
  select_bonus: 'Pilih Bonus',
  no_promotion: 'Tiada Promosi',
  please_upload_receipt: 'Sila muat naik resit',
  bank_account: 'Akaun Bank',
  add_account: 'Tambah Akaun',
  account_holder_name: 'Nama Pemegang Akaun',
  name_of_the_account_holder: 'Nama Pemegang Akaun',
  fill_in_bank_account: 'Isi Maklumat Akaun Bank',
  withdraw_information: 'Maklumat Pengeluaran',
  note: 'Nota',
  amount_withdrawn: 'Jumlah Dikeluarkan',
  amount_no_exceed_balance: 'Jumlah pengeluaran tidak boleh melebihi baki yang tersedia',
  minimum_withdraw_amount_is_x: 'Jumlah minimum pengeluaran ialah {{x}}',
  transaction_history: 'Sejarah Transaksi',
  date_from: 'Tarikh Dari',
  date_to: 'Tarikh Hingga',
  account_name_must_be_4: 'Nama Akaun mesti lebih daripada 4 aksara panjang',
  minimum_length_is_x: 'Panjang minimum ialah {{x}}',
  maximum_length_is_x: 'Panjang maksimum ialah {{x}}',
  payment_method: 'Kaedah Pembayaran',
  no_bank_account: 'Anda tidak mempunyai akaun untuk pengeluaran, Tambah sekarang',
  bet_history: 'Sejarah Pertaruhan',
  game_provider: 'Penyedia Permainan',
  bet_count: 'Kiraan Pertaruhan',
  win_loss: 'Menang/Rugi',
  rebate: 'Rebat',
  turnover: 'Perolehan',
  game_category: 'Kategori Permainan',
  you_have_x_unread_messages: 'Anda mempunyai {{x}} mesej yang belum dibaca',
  deposit_amount_between_x_and_y: 'Jumlah deposit mestilah antara {{x}} dan {{y}}',
  minimum_amount_is_x_y: 'Jumlah minimum ialah {{x}} {{y}}',
  all: 'Semua',
  title: 'Tajuk',
  date: 'Tarikh',
  type: 'Jenis',
  status: 'Status',
  remark: 'Catatan',
  category: 'Kategori',
  please_select_x: 'Sila pilih {{x}}',
  save: 'Simpan',
  change_password: 'Tukar Kata Laluan',
  current_password: 'Kata Laluan Semasa',
  confirm_password: 'Sahkan Kata Laluan Baru',
  submit: 'Hantar',
  password_changed: 'Kata Laluan Berjaya Ditukar',
  x_must_be_y_characters: '{{x}} mesti sekurang-kurangnya {{y}} aksara',
  reset_password: 'Tetapkan Semula Kata Laluan',
  slots: 'Slot',
  live_casino: 'Kasino Langsung',
  clear: 'Padam',
  search: 'Cari',
  new: 'Baru',
  logout: 'Log Keluar',
  choose_date: 'Pilih Tarikh',
  select_both_date: 'Pilih kedua-dua Tarikh Dari dan Hingga',
  from: 'Dari',
  to: 'Ke',
  apply: 'Guna',
  promotions: 'Promosi',
  learn_more: 'KETAHUI LEBIH LANJUT',
  password_doesnt_match: 'Kata Laluan tidak sepadan',
  cancel: 'Batal',
  confirm_to_pay: 'Sahkan Untuk Membayar',
  deposit_amount: 'Jumlah Deposit',
  loading_please_wait: 'Memuatkan, Sila Tunggu',
  account: 'Akaun',
  profile: 'Profil',
  bank_list: 'Senarai Bank',
  in_maintenance: 'Dalam Penyelenggaraan',
  birthday: 'Hari Lahir',
  birthday_bonus: 'Masukkan hari lahir anda untuk bonus! 🎉🎁',
  referral_code: 'Kod Rujukan',
  referral: 'Rujukan',
  my_referral: 'Rujukan Saya',
  my_claim: 'Tuntutan Saya',
  claim_profit: 'TUNTUT KEUNTUNGAN',
  available_profit: 'Keuntungan Tersedia',
  claimed_profit: 'Keuntungan Dituntut',
  all_time_profit: 'Keuntungan Sepanjang Masa',
  referral_note_on_x: 'Dapatkan keuntungan setiap kali rakan anda bermain di {{x}}',
  tier: 'Tahap',
  commission: 'Komisen',
  referred_member: 'Ahli Dirujuk',
  profit_earned: 'Keuntungan Diperoleh',
  account_information: 'Maklumat Akaun',
  invite_friends: 'Jemput Rakan',
  how_it_work: 'Bagaimana ia berfungsi?',
  invite_note: 'Dapatkan bonus rujukan eksklusif apabila rakan anda mendaftar menggunakan kod rujukan anda!',
  share_via: 'Kongsi melalui',
  referral_link: 'Pautan Rujukan',
  total_profit: 'Jumlah Keuntungan',
  copied: 'Disalin',
  nothing_to_claim: 'Tiada untuk Dituntut',
  claim_history: 'Sejarah Tuntutan',
  downline: 'Downline',
  last_x_digit_bank_ref_number: 'Digit terakhir {{x}} nombor rujukan bank',
  bank_ref_number_validation_x: 'Nombor Rujukan Bank diperlukan dan mesti {{x}} aksara panjang',
  login_directly: 'Log masuk terus dengan',
  our_game_provides: 'Penyedia Permainan Kami',
  linked_successfully_x: 'Berjaya dipautkan dengan {{x}}! Sila daftar akaun anda buat pertama kali',
  more_x_of_y: 'Lebih {{x}}/{{y}}',
  agent: 'Ejen',
  download: 'Muat Turun',
  popular: 'Popular',
  claim_bonus: 'Tuntut Bonus',
  currently_displaying: 'Sedang memaparkan {{x}} {{y}} permainan daripada {{z}}',
  no_results: 'Tiada Keputusan Ditemui',
  please_scan_using_your: 'Sila imbas menggunakan',
  activity_rules: 'Peraturan Aktiviti:',
  event_instructions: 'Arahan Acara',
  agent_p1: 'Kongsi pautan unik anda di aplikasi dan media sosial',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube, dan lain-lain. Jemput semua orang segera, ahli yang mendaftar melalui pautan eksklusif anda akan menjadi ejen langsung anda. Pastikan ahli baru yang anda jemput adalah sah dan asli.',
  agent_step1:
    'Apabila rakan jemputan anda membuat deposit pertama yang berjaya, anda boleh memenangi bonus sebanyak R$5. Sebagai contoh, jika anda menjemput 10 orang untuk membuat deposit pertama, anda boleh memperoleh R$50. Semakin ramai yang anda jemput, semakin banyak bonus yang anda terima. Anda boleh melihat sejarah dan mendaftar di halaman promosi.',
  agent_step2:
    'Jika tetamu anda membuat pertaruhan R$1 atau lebih, anda sudah boleh menikmati komisen tinggi! Anda boleh memperoleh sehingga 5% komisen sepanjang hayat. Sistem akan menyelesaikan komisen hari sebelumnya pada jam 7 pagi keesokan harinya.',
  agent_step2_1: 'Cara mendapatkannya: Log masuk - Promosi jemputan - Kumpul komisen',
  agent_table1: 'Kadar komisen pertaruhan untuk slot, memancing dan blockchain adalah seperti berikut:',
  agent_table1_1: 'Pelanggan tambah nilai 20 bertaruh 200',
  person: 'orang',
  agent_table2_title1: 'Pertaruhan Ahli',
  agent_table2_title2: 'Hanya Permainan Slot',
  agent_table2_example:
    'Contoh: Anda mempunyai 100 ahli, dan jumlah nilai sebenar pertaruhan dianggarkan pada 1 juta reais setiap hari. Komisen yang anda terima pada hari itu ialah: 1,000,000 x 1.20% = 12,000 reais. Pendapatan bulanan sebanyak 100,000 sangat mudah dicapai.',
  reminder: 'Peringatan',
  agent_reminder:
    'Akaun ahli dengan IP yang sama, peranti yang sama, nama, kad bank dan maklumat lain hanya boleh menyertai sekali, dan sesiapa yang melanggar peraturan tidak akan mendapat manfaat daripada bonus ini. Atau kumpulan itu akan dirampas dan akaun akan dibekukan secara kekal.',
  agent_step3_1:
    'Penyertaan ahli dalam aktiviti secara automatik dikira oleh sistem. Jika ada bantahan, keputusan analisis oleh IFUN168 akan diutamakan.',
  agent_step3_2:
    'Jika anda terlupa akaun/kata laluan ahli anda, sila hubungi pasukan khidmat pelanggan 24 jam kami untuk membantu anda mendapatkan semula maklumat akaun anda.',
  agent_step3_3: 'IFUN168 berhak mengubah, mengganggu atau membatalkan promosi pada bila-bila masa.',
  agent_step3_4: 'Ejen layak menerima bonus komisen dalam bentuk tunai atau kredit dalam dompet.',
  agent_step3_5: 'Jangan simpan permainan percuma, Beli permainan percuma.',
  agent_step3_6: 'Tidak boleh digabungkan dengan sebarang bonus dan deposit.',
  agent_step3_7: 'Hanya tersedia untuk permainan Slot.',
  promo_concluded: 'Promosi telah selesai! Kembali lagi esok!',
  can_only_claim: 'Hanya boleh tuntut bonus antara {{x}} hingga {{y}} Waktu Thailand',
  please_login: 'Sila log masuk terlebih dahulu untuk menuntut bonus!',
  back_to_home: 'Kembali ke Laman Utama',
  bonus_claimed: 'Bonus Telah Dituntut!',
  terms_n_conditions: 'TERMA DAN SYARAT',
  the_activity_x_in: 'Aktiviti {{x}} Dalam',
  starts: 'Bermula',
  ends: 'Berakhir',
  list_of_winners: 'SENARAI PEMENANG',
  days: 'Hari',
  hours: 'Jam',
  minutes: 'Minit',
  seconds: 'Saat',
  apply_now: 'Mohon Sekarang',
  number_exists: 'Nombor telefon ini telah didaftarkan!',
  number_not_exists: 'Nombor telefon ini tidak didaftarkan!',
  payment_draft:
    'Jika anda telah mengesahkan pembayaran, sila tunggu sebentar kerana pembayaran mungkin masih diproses.',
  downline_name: 'Nama Downline',
  date_joined: 'Tarikh Sertai',
  deposit_amount_x_days: 'Jumlah Deposit ({{x}} Hari)',
  dont_show_again: 'Jangan paparkan lagi',
  next: 'Seterusnya',
  close: 'Tutup',
  no_balance: 'Tiada Baki',
  menu: 'Menu',
  vip_club: 'Kelab VIP',
  home: 'Laman Utama',
  lobby: 'Lobi',
  show_all: 'Tunjuk Semua',
  game_name: 'Nama Permainan',
  sub_filters: 'Penapis Sub',
  contact_us_24: 'Hubungi Kami 24 Jam Perkhidmatan',
  live_chat: 'Sembang Langsung',
  chat_now: 'Sembang Sekarang',
  gaming_license: 'Lesen Permainan',
  certification: 'Sijil',
  security: 'Keselamatan',
  threatmetrix: 'ThreatMetrix',
  gaming_license_caption:
    'IFUN168 adalah entiti yang berlesen dan dikawal selia oleh kerajaan Curacao dan beroperasi secara sah di bawah Lesen Utama Penyedia Perkhidmatan Permainan, N.V #365/JAZ',
  no_limits: 'Tiada Had',
  vip_description_no_limits:
    'Kami menawarkan perkhidmatan VIP peribadi dengan syarat permainan unik kepada semua pemain di kelab VIP. Sekarang anda boleh bermain tanpa sebarang kebimbangan! Sangat mudah - bermain untuk keseronokan, tingkatkan kemahiran permainan anda, nikmati masa anda dan tiada had pada peluang kemenangan anda!',
  financial_privileges: 'Keistimewaan Kewangan',
  vip_description_financial_privileges:
    'Kelab VIP mengalu-alukan semua pemain yang ingin mendapatkan perkhidmatan VIP berkualiti tinggi. Keistimewaan eksklusif, promosi khas dan manfaat tersedia untuk anda di laman web kami! Status pemain VIP membuka had pengeluaran wang yang lebih tinggi dalam masa yang sangat singkat! Nikmatilah!',
  personal_manager: 'Pengurus Peribadi',
  vip_description_personal_manager:
    'Apakah kelebihan yang anda ingin peroleh apabila anda menjadi pemain VIP? Kongsi pemikiran anda dengan pengurus peribadi anda dan beritahu kami apa lagi yang anda ingin lihat di laman web kami! Kami sentiasa terbuka untuk cadangan hebat!',
  vip_promotions: 'Promosi VIP',
  vip_description_vip_promotions:
    'Adakah anda ingin mendapatkan lebih banyak promosi hebat? Pemain VIP yang setia menikmati semua ini dan banyak lagi sebagai ganjaran kesetiaan! Jadilah salah seorang daripadanya!',
  withdraw_limit: 'Had Pengeluaran',
  monthly: 'Bulanan',
  weekly: 'Mingguan',
  annual: 'Tahunan',
  cashback: 'Pulangan Tunai',
  personal_account_manager: 'Pengurus Akaun Peribadi',
  yes: 'Ya',
  join_the_vip: 'Sertai Program VIP Sekarang!',
  join_now: 'SERTAI SEKARANG',
  play_the_way_you_want: 'Main mengikut cara anda',
  more_info: 'Maklumat Lanjut',
  nothing_to_show: 'Tiada Apa Untuk Ditunjukkan',
  remarks: 'Ulasan',
  password: 'Kata Laluan',
  back: 'Kembali',
  new_to_x: 'Baru di {{x}}',
  create_an_account: 'Buat Akaun',
  withdraw_amount: 'Jumlah Pengeluaran',
  balance: 'Baki',
  bank_bsb: 'Bank BSB',
  enter_bank_branch: 'Masukkan Cawangan Bank',
  enter_pay_id: 'Masukkan ID Bayar',
  level: 'Tahap',
  claimed: 'Dituntut',
  not_found: 'Tidak Dijumpai',
  become_a_vip: 'Jadi VIP',
  otp_not_found: 'OTP Tidak Ditetapkan',
  resend_again: 'Hantar Semula',
  how_to_get_referral_bonus: 'Cara Mendapat Bonus Rujukan Rakan?',
  steps_to_claim: 'Langkah Untuk Menuntut Bonus',
  share_your_referral_code:
    '1. Kongsi kod rujukan anda kepada rakan-rakan untuk mendaftar akaun melalui Facebook, Twitter, atau WhatsApp.',
  after_friend_register:
    '2. Selepas rakan mendaftar dengan IFUN168, kedua-dua rujukan dan ahli rujukan perlu membuat deposit untuk menuntut bonus ini.',
  refer_a_friend_bonus: '3. Pengiraan bonus rujukan rakan:',
  turnover_played: 'Jumlah pertaruhan x % Komisyen = Bonus Rujukan Rakan',
  example: 'Contoh:',
  turnover_formula_x: 'Jumlah pertaruhan (1,000,000) x 0.002% (Komisyen %) = 2,000{{x}}',
  note_bonus_only: '*Nota: Bonus hanya boleh dituntut pada hari berikutnya selepas jam 12:00 pagi',
  note_bonus_only_x: '*Nota: Bonus hanya boleh dituntut pada hari berikutnya selepas {{x}}',
  access_dashboard:
    '4. Akses papan pemuka untuk menyemak keuntungan yang berhak, tahap komisyen, sejarah tuntutan, dan downline.',
  highlights: 'Sorotan',
  event: 'Acara',
  information: 'Maklumat',
  casino: 'Kasino',
  fish: 'Ikan',
  sports: 'Sukan',
  card: 'Kad',
  popular_games: 'Permainan Popular',
  game_providers: 'Penyedia Permainan',
  leaderboard: 'Papan Pendahulu',
  winnings: 'Winnings',
  vip_member_level: 'Tahap Ahli VIP',
  change_language: 'Tukar Bahasa',
  contact: 'Hubungi',
  choose_deposit_method: 'Pilih kaedah deposit',
  your_bank_account: 'Akaun Bank Anda',
  x_games: '{{x}} Permainan',
  x_game: '{{x}} Permainan',
  fishing: 'Memancing',
  please_enter_email: 'Sila masukkan emel anda',
  please_enter_new_password: 'Sila masukkan kata laluan baru anda',
  password_not_match: 'Kata laluan tidak sepadan',
  confirm_new_password: 'Sahkan Kata Laluan Baru',
  must_start_with: 'Nombor telefon mesti mempunyai sekurang-kurangnya 10 digit & bermula dengan (06 atau 08 atau 09)',
  first_name: 'Nama Pertama',
  last_name: 'Nama Akhir',
  to_proceed_further_add_bank: 'Untuk meneruskan, sila berikan maklumat bank anda',
  please_select_bank: 'Sila Pilih Bank',
  leave_empty_if_same_as_above: 'Biarkan kosong jika sama seperti di atas',
  deposit_from_bank: 'Deposit dari bank',
  select_language: 'Pilih Bahasa',
  logout_confirmation: 'Pengesahan Log Keluar',
  are_you_sure_to_logout: 'Adakah anda pasti mahu log keluar?',
};

export default ms;
